import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/authReducer";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Chip,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  Divider,
} from "@mui/material";

// project imports
import { menuActive } from "store/menuReducer";
import noImg from "assets/images/noImg.svg";

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

const NavItem = ({ item, level }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const menu = useSelector((state) => state.menu);
  // const Icon = Loadable(
  //   lazy(() =>
  //     import("@tabler/icons").then((module) => {
  //       return {
  //         default: module[item.icon],
  //       };
  //     })
  //   )
  // );
  // const itemIcon = item?.icon ? (
  //   <Icon stroke={1.5} size="1.3rem" />
  // ) : (
  //   <FiberManualRecordIcon
  //     sx={
  //       {
  //         // width: menu?.isActive.findIndex((id) => id === item?.id) > -1 ? 8 : 6,
  //         // height: menu?.isActive.findIndex((id) => id === item?.id) > -1 ? 8 : 6,
  //       }
  //     }
  //     fontSize={level > 0 ? "inherit" : "medium"}
  //   />
  // );

  let itemTarget = "_self";
  if (item.target) {
    itemTarget = "_blank";
  }

  let listItemProps = {
    component: forwardRef((props, ref) => (
      <Link ref={ref} {...props} to={`${item.path}`} />
    )),
  };
  if (item?.external) {
    listItemProps = { component: "a", href: item.url, target: itemTarget };
  }
  if (item?.path === "logout")
    listItemProps = {
      component: forwardRef((props, ref) => (
        <Link ref={ref} {...props} onClick={() => dispatch(logout())} />
      )),
    };

  /* useEffect(() => {
        console.log('menu', location?.pathname?.split('/')[1]);
        if (item?.url.includes(location?.pathname?.split('/')[1])) {
            dispatch({ type: MENU_OPEN, id: item.id });
        }
    }, [location, dispatch, item.id, item?.url]); */

  const itemHandler = (id) => {
    dispatch(menuActive(id));
  };

  return (
    <>
      {item?.flgSep && <Divider sx={{ bgcolor: "black" }} variant="hard" />}
      <ListItemButton
        key={item.title}
        {...listItemProps}
        disabled={item.disabled}
        sx={{
          mb: 0,
          alignItems: "flex-start",
          // backgroundColor: level > 1 ? "transparent !important" : "inherit",
          py: "0px",
          pl: `${level * 24}px`,
        }}
        selected={menu?.isActive.findIndex((id) => id === item.id) > -1}
        onClick={() => itemHandler(item.id)}
      >
        <ListItemIcon sx={{ my: "auto" }}>
          <img src={noImg} alt="Xcelvations Logo" height="18px" />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography
              variant="subtitle2"
              color="inherit"
              sx={{ fontSize: 12 }}
            >
              {item.title}
            </Typography>
          }
          secondary={
            item.caption && (
              <Typography
                variant="caption"
                sx={{ ...theme.typography.subMenuCaption }}
                display="block"
                gutterBottom
              >
                {item.caption}
              </Typography>
            )
          }
        />
        {item.chip && (
          <Chip
            color={item.chip.color}
            variant={item.chip.variant}
            size={item.chip.size}
            label={item.chip.label}
            avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
          />
        )}
      </ListItemButton>
    </>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number,
};

export default NavItem;
